import { useLocation } from 'react-router-dom';

export const useQueryParams = (): Record<string, string | number> => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const entries = Array.from(queryParams.entries());
  const numberRegExp = new RegExp(/^\d+$/);
  return entries.reduce<Record<string, string | number>>(
    (acc, item) => ({
      ...acc,
      [item[0]]: numberRegExp.test(item[1]) ? parseFloat(item[1]) : item[1],
    }),
    {}
  );
};
